export default "__VITE_PUBLIC_ASSET__118aabc1__"